import React, { useEffect, useState } from "react";
import firebase from "./config/firebase.js";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
export const AuthContext = React.createContext();


const useStyles = makeStyles((theme) => ({
  root: {
  flexGrow: 1,
  margin:theme.spacing(0),
  padding:theme.spacing(0),
  },
  title: {
  flexGrow: 1,
  textAlign:'left'
  }, 
  imgLogo: {
    width: "50px",
    marginRight: theme.spacing(1)
  },
  button: {
      margin: theme.spacing(1),
      float: 'right'
  },
}));

function GetBase() {
  const classes = useStyles();
  return (
  <>
  <AppBar position="sticky" color="default">
  <Toolbar id="back-to-top-anchor" >
    <img className={classes.imgLogo} src={require('./assets/img/logo.png')} />
    <Typography className={classes.title} variant="h6">Unidos Para Ayudar</Typography>
  </Toolbar>
  </AppBar>
  </>
  );
}

const handleLogout = () => {
  firebase.auth().signOut().then(function() {

  }).catch(function(error) {
      console.log(error)
  });
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(true);
  const [emailVerified, setEmailVerified] = useState(false);
  const [userProfile, setUserProfile] = useState(null);

  const reenviarConfirmacion = () => {
    currentUser.sendEmailVerification();
  }
  
  const classes = useStyles();
  useEffect(() => {
    
    firebase.auth().onAuthStateChanged((user) => {
      setCurrentUser(user);
      if(user) {
        if (user.emailVerified)
          setEmailVerified(true)
        
          const userProfile = {
            email       : user.email,
            nombre      : '',
            apellido    : '',
            celular     : '',
            cedula      : '',
            covid       : 0,
            created     : firebase.firestore.FieldValue.serverTimestamp()
          }
        const fetchDataUser = () => {
          firebase.firestore().collection('orgs').doc('unidos')
          .collection("users")
          .doc(user.uid)
          .get()
          .then(function(doc) {
            if (doc.exists) {
                setUserProfile(doc.data());
                setPending(false);        
            } else {
              firebase.firestore().collection('orgs').doc('unidos')
              .collection('users')
                .doc(user.uid).set(userProfile);
              setUserProfile(userProfile);
              setPending(false);        
            }
          }).catch(function(error) {
            console.log("Error getting  document:", error);
          });
        };
        fetchDataUser();
      }
      setPending(false);
    
    });


  }, []);

  if(pending){
    return (
      <div className={classes.root}>
      <GetBase />
      <br></br>
      <Container spacing={2}>
      <CircularProgress />
      </Container>
      </div>
    )
  }

  if(currentUser && !emailVerified){
    return (
      <div className={classes.root}>
      <GetBase />
      <br></br>
      <Container spacing={2}>
      <Grid container justify="space-around" alignItems="center" spacing={3}>
        <Grid item>
          <p>Necesitamos verificar su dirección de correo electrónico registrada:</p>
          <p>{currentUser.email}</p>
          <p>Para recibir el correo para validación haga clic en el siguiente botón.</p>
        </Grid>
        <Grid item>
          <Button onClick={reenviarConfirmacion} color="primary" variant="contained">
            Reenviar mail
          </Button>
          <Button onClick={handleLogout}>
            No es mi mail
          </Button>
        </Grid>
        <Grid item>
          <p>Luego de confirmar el mail refrezca esta pantalla y podrás acceder</p>
        </Grid>
      </Grid>
      </Container>
      </div>
    )
  }

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        userProfile,
        setUserProfile
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};